'use client';

import { FC, useEffect } from 'react';
import { shallow } from 'zustand/shallow';

import { recentFilterSearchStore } from '@/stores/recentFilterSearchStore';
import { FilterListPayload } from '@/types/CarFilters.types';

import { FilterParams } from '../PlpFilters/PlpFilters.type';
import { getPlpFiltersMap, mapFilterParamsToFormattedFilters } from '../PlpFilters/plpFiltersMap';

type Props = {
  plpParams?: FilterParams;
  filtersList: FilterListPayload;
};

export const RecentFilterResultHandler: FC<Props> = ({ plpParams, filtersList }) => {
  const { addFilterSearch } = recentFilterSearchStore((state) => ({ addFilterSearch: state.addFilterSearch }), shallow);

  const plpFiltersMap = getPlpFiltersMap(filtersList);
  const filters = mapFilterParamsToFormattedFilters(plpParams?.filter ?? '', plpFiltersMap);

  useEffect(() => {
    addFilterSearch(filters);
  }, [plpParams]);

  return <></>;
};
